import { render, staticRenderFns } from "./WholeSalePriceView.vue?vue&type=template&id=0855a304&scoped=true"
import script from "./WholeSalePriceView.vue?vue&type=script&lang=js"
export * from "./WholeSalePriceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0855a304",
  null
  
)

export default component.exports